"use client";

import { Compass, Box, Leaf, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    index: "§ 01.1",
    icon: Box,
    title: "Vigas",
    italicWord: "Estructurales",
    titleSuffix: "",
    description: "Perfiles de alta resistencia diseñados para soportar las cargas más exigentes en naves industriales y edificaciones de gran escala."
  }, {
    index: "§ 01.2",
    icon: Compass,
    title: "Canales",
    italicWord: "U y C",
    titleSuffix: "",
    description: "Soluciones versátiles para marcos, soportes y refuerzos secundarios, fabricados bajo los más estrictos estándares de calidad ASTM."
  }, {
    index: "§ 01.3",
    icon: Leaf,
    title: "Ángulos",
    italicWord: "de Acero",
    titleSuffix: "",
    description: "Componentes fundamentales para estructuras metálicas, torres de transmisión y herrería industrial con máxima durabilidad."
  }];
  return <section data-section-id="2110" id="productos-estructurales" className="relative overflow-hidden bg-background py-28 md:py-36 text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute right-[-4%] top-[2%] hidden select-none md:block" style={{
      fontFamily: "var(--font-serif)",
      fontSize: "clamp(320px, 52vw, 760px)",
      lineHeight: 0.8,
      color: "transparent",
      WebkitTextStroke: "1px var(--primary)",
      opacity: 0.06,
      fontWeight: 350
    }}>
        01
      </div>
      <div aria-hidden="true" className="pointer-events-none absolute right-[-8%] top-[1%] block select-none md:hidden" style={{
      fontFamily: "var(--font-serif)",
      fontSize: "320px",
      lineHeight: 0.8,
      color: "transparent",
      WebkitTextStroke: "1px var(--primary)",
      opacity: 0.06,
      fontWeight: 350
    }}>
        01
      </div>

      <div className="relative mx-auto max-w-[1440px] px-5 md:px-8 lg:px-14">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-6 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="lg:col-span-7">
            {}
            <div className="flex items-center gap-2 uppercase font-default" style={{
            fontSize: "0.6875rem",
            fontWeight: 600,
            letterSpacing: "0.18em",
            lineHeight: 1
          }}>
              <span className="text-accent">§ 01</span>
              <span className="text-muted-foreground">—</span>
              <span className="text-muted-foreground">PRODUCTOS ESTRUCTURALES / KALISCH ACERO</span>
            </div>

            {}
            <div className="mt-5 flex items-center gap-3">
              <div className="h-px flex-1 bg-border" />
              <div className="flex items-center gap-1">
                <span className="h-1 w-1 rounded-lg bg-accent" />
                <span className="h-1 w-1 rounded-lg bg-accent" />
                <span className="h-1 w-1 rounded-lg bg-accent" />
              </div>
            </div>

            {}
            <h2 className="mt-8 font-default" style={{
            fontSize: "clamp(2.25rem, 4.8vw, 4.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.02,
            color: "var(--primary)"
          }}>
              Solidez en cada,{" "}
              <br className="hidden sm:block" />
              proyecto{" "}
              <em className="font-default" style={{
              fontStyle: "italic",
              fontWeight: 400
            }}>
                industrial
              </em>
              .
            </h2>
          </div>

          <div className="lg:col-span-5 lg:flex lg:items-end">
            <p className="font-default max-w-md text-muted-foreground" style={{
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
            fontWeight: 400,
            lineHeight: 1.55
          }}>
              En Kalisch Acero suministramos los perfiles estructurales necesarios para cimentar el futuro de la industria, garantizando resistencia y precisión técnica en cada pieza.
            </p>
          </div>
        </div>

        {}
        <div ref={cardsRef} className="mt-20 grid grid-cols-1 gap-6 md:gap-7 lg:grid-cols-12 lg:gap-6">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={i} data-index={i} className={`lg:col-span-4 transition-all ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDuration: "720ms",
            transitionDelay: `${i * 80}ms`
          }}>
                <Card className="group relative h-full overflow-hidden p-9 transition-transform duration-300 ease-out hover:-translate-y-1 bg-card shadow-md rounded-lg border-none" style={{
              color: "var(--foreground)"
            }}>
                  {}
                  <span aria-hidden="true" className="pointer-events-none absolute left-3 top-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderTop: "1px solid var(--accent)",
                borderLeft: "1px solid var(--accent)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute right-3 top-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderTop: "1px solid var(--accent)",
                borderRight: "1px solid var(--accent)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-3 left-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderBottom: "1px solid var(--accent)",
                borderLeft: "1px solid var(--accent)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-3 right-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderBottom: "1px solid var(--accent)",
                borderRight: "1px solid var(--accent)"
              }} />

                  {}
                  <div className="flex items-center gap-2 uppercase font-default" style={{
                fontSize: "0.6875rem",
                fontWeight: 600,
                letterSpacing: "0.18em",
                lineHeight: 1
              }}>
                    <span className="text-accent">{pillar.index}</span>
                    <span className="text-muted-foreground">—</span>
                    <span className="text-muted-foreground">CATÁLOGO</span>
                  </div>

                  {}
                  <div className="mt-8 transition-transform duration-[400ms] ease-out group-hover:rotate-6">
                    <Icon size={32} strokeWidth={1.5} className="text-primary" />
                  </div>

                  {}
                  <h3 className="mt-7 font-default" style={{
                fontSize: "clamp(1.5rem, 2.2vw, 2.25rem)",
                fontWeight: 700,
                letterSpacing: "-0.012em",
                lineHeight: 1.15,
                color: "var(--primary)"
              }}>
                    {pillar.title}{" "}
                    <em className="font-default" style={{
                  fontStyle: "italic",
                  fontWeight: 400
                }}>
                      {pillar.italicWord}
                    </em>
                  </h3>

                  {}
                  <p className="font-default mt-5 text-muted-foreground" style={{
                fontSize: "1rem",
                fontWeight: 400,
                letterSpacing: "0.005em",
                lineHeight: 1.65
              }}>
                    {pillar.description}
                  </p>

                  {}
                  <div className="mt-9 flex items-center gap-3">
                    <div className="h-px flex-1 bg-border" />
                    <div className="flex items-center gap-1">
                      <span className="h-1 w-1 rounded-lg bg-accent" />
                      <span className="h-1 w-1 rounded-lg bg-accent" />
                      <span className="h-1 w-1 rounded-lg bg-accent" />
                    </div>
                  </div>

                  {}
                  <div className="mt-6">
                    <button type="button" className="group/link relative inline-flex items-center gap-2 font-default text-accent" style={{
                  fontSize: "0.9375rem",
                  fontWeight: 600
                }}>
                      <span className="relative">
                        Ver especificaciones
                        <span className="absolute -bottom-0.5 left-0 h-px w-0 transition-all duration-300 ease-out group-hover/link:w-full bg-accent" />
                      </span>
                      <ArrowRight size={16} strokeWidth={2} className="transition-transform duration-300 group-hover/link:translate-x-1" />
                    </button>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}